import { normalizeAdditionalInfo } from '@brands/Utils/additionalInfo';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { ICase } from './types/ICase';

export interface CaseIntakeQuestions {
  is_dental_emergency?: boolean;
  in_pain?: boolean;
  pain_description?: string[];
  pain_time?: string;
  pain_level?: string;
  additional_info?: string;
  reason_for_visit?: string[];
}

export type CasePayload = {
  type?: string;
  status?: string;
  patient_id?: number;
  organization_id?: string;
  provider_id?: number;
  video_conference_date?: string | null;
  video_conference_other_participants?: string | null;
  payment_profile_id?: number | null;
  patient_current_state?: string;
  insurance_id?: number | null;
  second_insurance_id?: number | null;
  /** The insurance id that passed verify_insurance */
  used_insurance_id?: number | null;
  cdts?: string[] | null;
  dependent_id?: number | null;
  is_term_accepted?: boolean;
  tz?: string | null;
  license_states?: string[] | null;
  follow_up_status?: string;
  case_intake_questions?: CaseIntakeQuestions;
  intake_answers?: Record<string, any>;
};

export const createNewCase = async (payload: CasePayload, userRole?: string): Promise<ICase> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const path = prefix ? `${prefix}/cases` : '/cases';

  const normalizedPayload: CasePayload = { ...payload };
  if (payload.case_intake_questions) {
    const caseIntakeQuestions = { ...payload.case_intake_questions };
    const additionalInfo = normalizeAdditionalInfo(caseIntakeQuestions.additional_info);
    delete caseIntakeQuestions.additional_info;
    if (additionalInfo) caseIntakeQuestions.additional_info = additionalInfo;
    normalizedPayload.case_intake_questions = caseIntakeQuestions;
  }

  if (payload.intake_answers) {
    const intakeAnswers = { ...payload.intake_answers };
    const noteToDentist = normalizeAdditionalInfo(intakeAnswers.note_to_dentist);
    delete intakeAnswers.note_to_dentist;
    if (noteToDentist) intakeAnswers.note_to_dentist = noteToDentist;
    normalizedPayload.intake_answers = intakeAnswers;
  }

  const { data } = await client.post<ICase>(path, normalizedPayload);

  return data;
};
